import { atom, DefaultValue, selector } from "recoil"

export const webSocketDisconnectReasonAtom = atom({
  key: "webSocketDisconnectReasonAtom",
  default: -1
})

export const pageVisibilityStatus = atom({
  key: "pageVisibilityStatus",
  default: false
})

export const pageInActiveTimerAtom = atom<number>({
  key: "pageInActiveTimerAtom",
  default: -1
})

export const handleWebsocketDisconnectSelector = selector<{
  reason: number
  pageInActiveTime?: number
}>({
  key: "handleWebsocketDisconnectSelector",
  get: ({ get }) => ({
    reason: get(webSocketDisconnectReasonAtom),
    pageInActiveTime: get(pageInActiveTimerAtom)
  }),
  set({ set }, action) {
    if (action instanceof DefaultValue) {
      return
    }

    const { reason } = action
    set(webSocketDisconnectReasonAtom, reason)
  }
})

export const handlePageVisibilityStatusSelector = selector<{
  status: boolean
}>({
  key: "handlePageVisibilityStatusSelector",
  get: ({ get }) => ({
    status: get(pageVisibilityStatus)
  }),
  set({ set }, action) {
    if (action instanceof DefaultValue) {
      return
    }

    const { status } = action
    set(pageVisibilityStatus, status)
    if (!status) {
      set(pageInActiveTimerAtom, Date.now())
    }
  }
})
